import React, { useEffect, useState } from "react";

import { Button, Modal } from "shared/ui";

import { OrderEntry, OrderList } from "features/MenuEditor/components/OrderList";

interface OrderDialogProps {
    title: string;
    description?: React.ReactNode;
    entries: OrderEntry[];
    emptyText: string;
    saving: boolean;
    onClose: () => void;
    onSubmit: (orderedIds: number[]) => void;
}

export const OrderDialog = ({
    title,
    description,
    entries,
    emptyText,
    saving,
    onClose,
    onSubmit,
}: OrderDialogProps) => {
    const [ordered, setOrdered] = useState<OrderEntry[]>(entries);

    useEffect(() => setOrdered(entries), [entries]);

    return (
        <Modal
            open
            onClose={onClose}
            title={title}
            actions={
                <>
                    <Button variant="outlined" color="neutral" disabled={saving} onClick={onClose}>
                        Отмена
                    </Button>
                    <Button
                        variant="contained"
                        disabled={saving || ordered.length === 0}
                        onClick={() => onSubmit(ordered.map((entry) => entry.id))}
                    >
                        Сохранить
                    </Button>
                </>
            }
        >
            {description}
            <OrderList entries={ordered} onReorder={setOrdered} emptyText={emptyText} />
        </Modal>
    );
};
